import React, { Component } from 'react';
import { joinClasses } from 'components/utils/react_helper';

export default class TransistionDots extends Component {
  render() {
    return (
      <span className={joinClasses(['transition-animation', this.props.className])}>
        <span className='transition-dot'>.</span>
        <span className='transition-dot'>.</span>
        <span className='transition-dot'>.</span>
      </span>
    );
  }
}